import { richTextResolver } from "@website-builder/utilities-index";
import { getUniqueId, formatCurrency } from "@website-builder/utilities-index";

const createAccordionItems = (
	paymentPlans = [],
	isUpfrontSectionRequired,
	isMonthlySectionRequired,
	isClimbCreditSectionRequired,
	otherAccordionItems,
	globalVariableWithURL,
) => {
	let upfrontPrice = "";
	let monthlyPrice = "";
	let numOfMonths = "";
	let discount = "";
	let undiscountedPrice = "";
	if (!!paymentPlans.length) {
		paymentPlans.forEach((plan) => {
			if (plan.is_subscription) {
				monthlyPrice = plan.undiscounted_price;
				numOfMonths = plan.max_charge_count;
			} else if (!plan.is_credit_enabled) {
				upfrontPrice = plan.price.toFixed();
			}
		});
		undiscountedPrice = (monthlyPrice * numOfMonths).toFixed();
		discount =
			monthlyPrice && numOfMonths
				? (
						((undiscountedPrice - upfrontPrice) * 100) /
						undiscountedPrice
					).toFixed()
				: "";
	}

	const additionalItems = otherAccordionItems.map(
		({ _uid, name, badge, content }) => ({
			_uid,
			name,
			badge,
			footerText: {
				value: richTextResolver(content, globalVariableWithURL),
			},
			components: [],
		}),
	);

	return {
		value: {
			options: [
				{
					isRequired: isUpfrontSectionRequired,
					name: `Upfront discount`,
					badge: `BEST VALUE`,
					_uid: getUniqueId(),
					footerText: {
						value: `The full tuition of the program is $${formatCurrency(
							undiscountedPrice,
						)}. Pay upfront and save ${discount}% on tuition.`,
					},
					components: [],
					priceSubtext: {
						withScholarship: null,
						withoutScholarship: {
							value: "$" + formatCurrency(undiscountedPrice),
							struckOff: true,
							position: "left",
						},
					},
					actualPrice: {
						withoutScholarship: "$" + formatCurrency(upfrontPrice),
					},
				},
				{
					isRequired: isMonthlySectionRequired,
					name: `Month-to-month`,
					badge: `MOST FLEXIBLE`,
					_uid: getUniqueId(),
					footerText: {
						value: `Pay ${numOfMonths} payments while in the program, totaling $${formatCurrency(
							undiscountedPrice,
						)}.`,
					},
					components: [],
					actualPrice: {
						withoutScholarship: `$${formatCurrency(
							Math.round(monthlyPrice),
						)}/mo`,
					},
					priceSubtext: {
						withScholarship: null,
						withoutScholarship: {
							value: `Total: Up to $${formatCurrency(undiscountedPrice)}`,
							struckOff: false,
							position: "bottom",
						},
					},
				},
				{
					isRequired: isClimbCreditSectionRequired,
					name: "Climb credit loan",
					badge: `LOW MONTHLY PAYMENTS`,
					_uid: getUniqueId(),
					footerText: {
						value: `
            <ul>
              <li><p>Pay a deposit at the time of enrollment.</p></li>
              <li><p>Make payments for a duration 24 - 42 months depending on loan type.</p></li>
              <li><p>0% APR options may be available to those who qualify.</p></li>
            </ul>
            <p>Apply and speak with an enrollment advisor to learn more about your specific financing options.</p>
            <br/>
            <p><i>Please note: lending might not be available in all 50 states - </i><a href="https://climbcredit.zendesk.com/hc/en-us/articles/4415269456659-Where-is-Climb-licensed-to-lend" target="_blank" linktype="url"><i>view the full lending list.</i></a></p>`,
					},
					components: [],
				},
			]
				.filter((item) => item.isRequired)
				.concat(additionalItems),
			scholarship: {
				enable: false,
				text: "",
			},
		},
	};
};

export default (
	{
		label = "",
		headline = "",
		description = "",
		isUpfrontSectionRequired,
		isMonthlySectionRequired,
		isClimbCreditSectionRequired,
		otherAccordionItems = [],
	},
	{ story: { shortName = "", programName = "" }, globalVariableWithURL = [] },
) => {
	const getAccordionItems = (paymentPlans) =>
		createAccordionItems(
			paymentPlans,
			isUpfrontSectionRequired,
			isMonthlySectionRequired,
			isClimbCreditSectionRequired,
			otherAccordionItems,
			globalVariableWithURL,
		);
	return {
		label,
		headline,
		description: richTextResolver(description, globalVariableWithURL),
		shortname: shortName && shortName.trim(),
		programName,
		getAccordionItems,
	};
};
